import { Navigate, useLocation } from "react-router-dom";

import { INSIDE_SALES_SALES_ORDERS_PATH } from "@/lib/hubEntityDetailPaths";

/** Old `/sales-orders` module URLs redirect into Inside Sales. */
export function RedirectSalesOrdersToInsideSales() {
  const location = useLocation();
  const rest = location.pathname.replace(/^\/sales-orders/, "");
  return (
    <Navigate to={`${INSIDE_SALES_SALES_ORDERS_PATH}${rest}${location.search}${location.hash}`} replace />
  );
}
